<div class="page-container gap-24">
  <div class="page-title justify-space-between">
    <span class="font-bold-display-medium"> News Banners </span>
    <button
      type="button"
      class="inwi-text-button-medium-secondary"
      (click)="navigateToCreateNewsBanner()">
      <div class="button-content">
        <div class="button-icon">
          <i class="fa-regular fa-plus"></i>
        </div>
        <div class="button-text">Banner hinzufügen</div>
      </div>
    </button>
  </div>
  <div>
    <app-news-banner-slider
      [newsBannerSlides]="newsBannerSlides"
      [isLoading]="isLoading"
      (onDelete)="onDeleteNewsBanner($event)"
      (onEdit)="navigateToEditNewsBanner($event)">
    </app-news-banner-slider>
  </div>
  <div class="page-title">
    <span class="title-content">
      <i
        class="fa-regular fa-arrows-up-down-left-right font-medium-display-small"></i>
      <span class="font-medium-display-small"> Folienreihenfolge </span>
    </span>
  </div>
  <app-news-banner-slide-sequence
    [newsBanners]="newsBanners"
    (newsBannersChange)="
      onNewsBannersChanged($event)
    "></app-news-banner-slide-sequence>
</div>
